__turbopack_context__.v({
  "empty": "LinkIconButton-module__YQVjqq__empty",
  "filled": "LinkIconButton-module__YQVjqq__filled",
  "main": "LinkIconButton-module__YQVjqq__main",
  "outlined": "LinkIconButton-module__YQVjqq__outlined",
  "rounded": "LinkIconButton-module__YQVjqq__rounded",
  "selected": "LinkIconButton-module__YQVjqq__selected",
  "square": "LinkIconButton-module__YQVjqq__square",
});
